export const splitByNewLine = (data: string): string[] => {
    if (data) {
        let lines =  data.split(/\r\n|\r|\n/);
        if (lines[lines.length-1] === "") {
            lines.splice(lines.length-1, 1)
        }
        return lines;
    }
    return [];
}

export const ParseListsFromTextFile = (fileContents: string): string[] => {
    let lists: string[] = [];

    if (fileContents) {
        const textByLine: string[] = fileContents.split('\n');
        let listItem: string = '';
        textByLine.forEach((line) => {

            // if it's a blank line, end of this list, move on
            if (line.trim() === '') {
                if (listItem !== '') {
                    lists.push(listItem);
                }
                listItem = '';

            } else {
                listItem = listItem.length > 0 ? listItem + '\n' + line : line;
            }
        });

        // append remainder, if neccessary
        if (listItem !== '') {
            lists.push(listItem);
        }
    }

    return lists;
}
